<div class="p-6 space-y-6" id="page-roles">
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h2 class="text-xl font-bold text-gray-900 dark:text-white">Roles y Permisos</h2>
      <p class="text-sm text-gray-400 dark:text-gray-500">Gestión de roles de acceso al sistema</p>
    </div>
    <button type="button" class="btn btn-primary gap-2 w-full sm:w-auto">
      <svg class="w-4 h-4"><use href="/svg/sprite.svg#plus-sign"/></svg>
      Nuevo Rol
    </button>
  </div>
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800
            overflow-hidden">
    <div class="px-4 py-3 border-b border-gray-100 dark:border-gray-800 flex flex-col sm:flex-row gap-3">
      <label class="input w-full sm:flex-1">
        <svg class="w-4 h-4 opacity-50"><use href="/svg/sprite.svg#search-icon"/></svg>
        <input type="text" placeholder="Buscar rol..." class="grow" />
      </label>
      <select class="select w-full sm:w-auto">
        <option>Nivel: Todos</option>
        <option>Máximo</option>
        <option>Alto</option>
        <option>Medio</option>
        <option>Bajo</option>
      </select>
      <select class="select w-full sm:w-auto">
        <option>Estado: Todos</option>
        <option>Activo</option>
        <option>Inactivo</option>
      </select>
    </div>
    <div class="overflow-x-auto">
      <table class="w-full">
        <thead class="bg-gray-50 dark:bg-gray-800/50">
          <tr>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-6 py-3 dark:text-gray-500
                      uppercase">Rol</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Descripción</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Usuarios</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Nivel</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Estado</th>
            <th class="text-left text-xs font-semibold text-gray-400 tracking-wider px-4 py-3 dark:text-gray-500
                      uppercase">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-50 dark:divide-gray-800">
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4">
              <div class="items-center flex gap-3">
                <div class="w-8 h-8 rounded-xl bg-red-100 dark:bg-red-900/30 items-center justify-center flex">
                  <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_ADb58UnPc"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
                </div>
                <span class="text-sm font-semibold text-gray-800 dark:text-gray-200">Super Admin</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Acceso total al sistema</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">2</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-red-100 dark:bg-red-900/30 text-red-600 px-2 py-0.5 rounded-lg font-medium
                        dark:text-red-400">Máximo</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Activo</span>
            </td>
            <td class="px-4 py-4">
              <div class="flex gap-1">
                <button type="button" class="btn btn-ghost btn-square btn-sm">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
                </button>
                <button type="button" class="btn btn-ghost btn-square btn-sm text-error">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#trash-stroke-icon"/></svg>
                </button>
              </div>
            </td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4">
              <div class="items-center flex gap-3">
                <div class="w-8 h-8 rounded-xl bg-orange-100 dark:bg-orange-900/30 items-center justify-center
                          flex">
                  <svg class="w-4 h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_5zYhxHC91"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
                </div>
                <span class="text-sm font-semibold text-gray-800 dark:text-gray-200">Gestor Senior</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Gestión completa de proyectos</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">8</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-orange-100 dark:bg-orange-900/30 text-orange-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-orange-400">Alto</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Activo</span>
            </td>
            <td class="px-4 py-4">
              <div class="flex gap-1">
                <button type="button" class="btn btn-ghost btn-square btn-sm">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
                </button>
                <button type="button" class="btn btn-ghost btn-square btn-sm text-error">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#trash-stroke-icon"/></svg>
                </button>
              </div>
            </td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4">
              <div class="items-center flex gap-3">
                <div class="w-8 h-8 rounded-xl bg-blue-100 dark:bg-blue-900/30 items-center justify-center flex">
                  <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_CUxqajjSi"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
                </div>
                <span class="text-sm font-semibold text-gray-800 dark:text-gray-200">Gestor Junior</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Seguimiento de tareas asignadas</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">15</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-blue-100 dark:bg-blue-900/30 text-blue-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-blue-400">Medio</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Activo</span>
            </td>
            <td class="px-4 py-4">
              <div class="flex gap-1">
                <button type="button" class="btn btn-ghost btn-square btn-sm">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
                </button>
                <button type="button" class="btn btn-ghost btn-square btn-sm text-error">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#trash-stroke-icon"/></svg>
                </button>
              </div>
            </td>
          </tr>
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
            <td class="px-6 py-4">
              <div class="items-center flex gap-3">
                <div class="w-8 h-8 rounded-xl bg-green-100 dark:bg-green-900/30 items-center justify-center
                          flex">
                  <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_7tYZmEShQ"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
                </div>
                <span class="text-sm font-semibold text-gray-800 dark:text-gray-200">Cliente (Solo lectura)</span>
              </div>
            </td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">Visualización de sus proyectos</td>
            <td class="px-4 py-4 text-sm text-gray-600 dark:text-gray-400">48</td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Bajo</span>
            </td>
            <td class="px-4 py-4">
              <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg
                        font-medium dark:text-green-400">Activo</span>
            </td>
            <td class="px-4 py-4">
              <div class="flex gap-1">
                <button type="button" class="btn btn-ghost btn-square btn-sm">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#pencil-icon"/></svg>
                </button>
                <button type="button" class="btn btn-ghost btn-square btn-sm text-error">
                  <svg class="w-4 h-4"><use href="/svg/sprite.svg#trash-stroke-icon"/></svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

